import { render, staticRenderFns } from "./promocionesVer.vue?vue&type=template&id=18d2d428&scoped=true&"
import script from "./promocionesVer.vue?vue&type=script&lang=js&"
export * from "./promocionesVer.vue?vue&type=script&lang=js&"
import style0 from "./promocionesVer.vue?vue&type=style&index=0&id=18d2d428&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d2d428",
  null
  
)

export default component.exports